// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#DestinationHead{transform:translateY(100px)}#DestinationHead .title{line-height:1rem}", "",{"version":3,"sources":["webpack://./src/styles/matrix/DestinationHead.scss"],"names":[],"mappings":"AAAA,iBACE,2BAAA,CAEA,wBACA,gBAAA","sourcesContent":["#DestinationHead {\n  transform: translateY(100px);\n\n  .title {\n  line-height: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
